const NEGATIVE_OPERATORS = ['absent', 'not_equals'];

// The API supplies display names; deleted labels never fall back to stale IDs.
const describeLabelCondition = (condition) => {
  const names = condition.label_names || [null];
  const joined = names.map((name) => (name ? `"${name}"` : 'deleted label')).join(' or ');
  return NEGATIVE_OPERATORS.includes(condition.operator) ? `no label ${joined}` : `label ${joined}`;
};

export default describeLabelCondition;
